import classesData from '@/src/router/views/classes/classes.json'
import GRAPH_CONSTANTS from '@src/constants/graph-constants.js'
import GENERAL_CONSTANTS from '@src/constants/general-constants'

export const rightBarStats = (classCounts, currentCampusScope, totalClasses) => {
  const stats = [
    {
      title: GENERAL_CONSTANTS.STATS_AND_SUMMARY,
      categories: [
        {
          text: totalClasses,
          value: classCounts,
          tooltipDescription: !currentCampusScope
            ? classesData.tooltipDescriptionInstitute
            : classesData.tooltipDescriptionCampus,
        },
      ],
    },
  ]
  return stats
}
